module.exports = __webpack_public_path__ + "img/landliebe-6415.52c6a5d0.jpg";